import { useDispatch } from 'react-redux';
import styled, { css } from 'styled-components';
import { NAVERWORKS_DRIVE_TYPE } from '../../define/naverworksDefine';
import { closeContextMenu } from '../../store/modules/contextMenu';
import IconFolder_16 from '../../img/ico_folder_16.png';
import IconFolder_16_2X from '../../img/ico_folder_16@2x.png';
import { CustomScrollbar } from '../common/CssCommon';

const Wrapper = styled.div`
  max-width: 150px;
  max-height: 300px;
  overflow-x: hidden;
  overflow-y: auto;
  ${CustomScrollbar}

  ${({ isMobile }) =>
    isMobile &&
    css`
      @media (orientation: portrait) {
        max-width: 100px;
        max-height: 100px;
      }
      @media (orientation: landscape) {
        max-width: 300px;
        max-height: 100px;
      }
    `}
`;

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 6px 24px 7px 8px;
  font-size: 13px;
  color: #2f3133;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  align-items: center;
  gap: 12px;
  cursor: pointer;
`;

const Icon = styled.img`
  width: 16px;
  height: 16px;
`;

const Text = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;
`;

export default function ContextMenuFolderPath({ paths, onClick, isMobile }) {
  const dispatch = useDispatch();

  const onCloseContextMenu = (prop) => {
    dispatch(closeContextMenu(prop));
  };

  return (
    <Wrapper isMobile={isMobile}>
      {paths.map((item) => (
        <ItemWrapper
          key={item.folderId}
          onClick={() => {
            onClick(NAVERWORKS_DRIVE_TYPE.PERSONAL, 'me', item.folderId, item.folderName);
            onCloseContextMenu();
          }}>
          <Icon src={IconFolder_16} srcSet={IconFolder_16_2X} />
          <Text title={item.folderName}>{item.folderName}</Text>
        </ItemWrapper>
      ))}
    </Wrapper>
  );
}
